import React from 'react';
import PropTypes from 'prop-types';
import LogoWordless from '../../assets/logo/logoWordless.svg';
import { Container, StyledH3 } from './css';

const HomePageFooter = ({ fields }) => (
  <Container>
    <img src={LogoWordless} alt="Logo Wordless" />
    <StyledH3 field={fields.heading} />
  </Container>
);

HomePageFooter.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.object,
  }),
};

export default HomePageFooter;
